import {
  CART_ADD_SUCCESS,
  CART_ADD_FAIL,
  CART_REMOVE,
  UPDATE_FROM_SERVER,
} from "./types";
import axios from "axios";
import { apiURL } from "../config/default";
import setAuthHeader from "../utils/setAuthHeader";

export const cartAdding = (data) => {
  console.log(data);
};
export const cartAdd = (data) => (dispatch) => {
  console.log(data);
  try {
    dispatch({
      type: CART_ADD_SUCCESS,
      payload: data,
    });
    return data;
  } catch (err) {
    dispatch({
      type: CART_ADD_FAIL,
    });
  }
};

export const cartRemove = (data) => async (dispatch) => {
  try {
    dispatch({
      type: CART_REMOVE,
      payload: data,
    });
    return data;
  } catch (err) {
    dispatch({
      type: CART_ADD_FAIL,
    });
  }
};

export const getCart = () => async (dispatch) => {
  try {
    const res = localStorage.getItem("cart");
    return JSON.parse(res);
  } catch (err) {
    return "cart empty";
  }
};

export const sendCartToServer = (body) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  console.log(body);
  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }

  try {
    const res = await axios.post(`${apiURL}products-stock`, body, _config);

    return res;
  } catch (err) {}
};

export const cartDataUpdate = (statusFromServer) => (dispatch) => {
  console.log(statusFromServer);

  const cartProductData = JSON.parse(localStorage.getItem("cart"));
  cartProductData.map((cartItem, index) => {
    statusFromServer.map((serverCartItem) => {
      if (serverCartItem === cartItem && serverCartItem.outOfStock === true) {
        cartProductData.splice(index, 1);
      }
      if (serverCartItem === cartItem) {
        cartItem.item.price = serverCartItem.price;
      }
    });
  });

  try {
    dispatch({
      type: UPDATE_FROM_SERVER,
      payload: cartProductData,
    });
    return cartProductData;
  } catch (err) {
    dispatch({
      type: CART_ADD_FAIL,
    });
  }

  console.log(cartProductData);
};
